import type { FC } from 'react';
import type { SliderProps } from '@radix-ui/react-slider';
import { Range, Root, Thumb,Track } from '@radix-ui/react-slider';
import cn from 'classnames';

import classes from './index.module.css';

type Props = SliderProps & {
  className?: string;
  onValueChange(value: number): void;
};

const Slider: FC<Props> = ({ value, min, max, step, className, onValueChange }) => {
  const onChange: SliderProps['onValueChange'] = (value) => onValueChange(value?.[0]);

  return (
    <Root
      className={cn(classes.root, className)}
      value={value}
      min={min}
      max={max}
      step={step}
      orientation="horizontal"
      onValueChange={onChange}
    >
      <Track className={classes.track}>
        <Range className={classes.range} />
      </Track>
      <Thumb className={classes.thumb} />
    </Root>
  );
};

Slider.defaultProps = {
  className: '',
  value: [0],
  min: 0,
  max: 100,
  step: 1,
};

export default Slider;
